import * as React from "react";
import { Dropdown } from "react-bootstrap";
import { DriveUIActionTypes, Feature, DriveFeature, useAppSelector, isUploadInProgress, PreveilDownloads } from "src/common";
import { Icon } from "src/components";
import { DropdownProps, WatchedSwitchItem } from ".";
import { selectIsPreveilDownloadsRoot } from "src/store";
import { RootState } from "src/store/configureStore";

function LinkMenuComponent(props: DropdownProps) {
  const { current_account, entry, all_actions, collection_info, current_details, handleAction } = props;
  const permissions = collection_info?.permissions;
  const upload_folder_ids = useAppSelector((state: RootState) => state.ui.upload_folder_ids);
  const under_downloads = useAppSelector(selectIsPreveilDownloadsRoot) || entry.name === PreveilDownloads;
  const uploading_in_progress = isUploadInProgress(entry, upload_folder_ids);

  return <>
    <Dropdown.Item aria-label="Details"
      hidden={!all_actions}
      data-tooltip-id="dd-tooltip" data-tooltip-content="Shared Folder Details"
      data-tooltip-place="right"
      onClick={() => handleAction({ actionType: DriveUIActionTypes.Details, params: { entry, action: DriveUIActionTypes.Details } })}>
      <Icon className="pv-icon-finder" />Details
    </Dropdown.Item>
    {/* Require user permissions for the collection */}
    {
      !!permissions &&
      <>
        <Dropdown.Item aria-label="Copy Link"
          data-tooltip-id="dd-tooltip" data-tooltip-content="Copy Link to Shared Folder"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.CopyLink, params: entry })}>
          <Icon className="ficon-link" />Copy Link
        </Dropdown.Item>
        <Dropdown.Item aria-label="Rename"
          hidden={Feature.hidden(DriveFeature.Rename, permissions)}
          data-tooltip-id="dd-tooltip" data-tooltip-content="Rename Shared Folder"
          data-tooltip-place="right"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.Details, params: { entry, action: DriveUIActionTypes.Rename } })}>
          <Icon className="pv-icon-compose" />Rename
        </Dropdown.Item>
        {!uploading_in_progress && <>
          <Dropdown.Item aria-label="Remove from My PreVeil"
            hidden={Feature.hidden(DriveFeature.Delete)}
            data-tooltip-id="dd-tooltip"
            data-tooltip-content="Hide this shared folder from My PreVeil"
            data-tooltip-place="right"
            onClick={() => handleAction({ actionType: DriveUIActionTypes.Delete, params: entry })}>
            <Icon className="ficon-eye-off" />Hide
          </Dropdown.Item>
          <Dropdown.Item aria-label="Share"
            // NOTE: Disable if the folder is PreveilDownloads OR if it is a child of it
            hidden={Feature.hidden(DriveFeature.Share, permissions) || under_downloads}
            data-tooltip-id="dd-tooltip" data-tooltip-content="Share Folder"
            data-tooltip-place="right"
            onClick={() => handleAction({ actionType: DriveUIActionTypes.Details, params: { entry, action: DriveUIActionTypes.Share } })}>
            <Icon className="pv-icon-share" />Share
          </Dropdown.Item>
          <Dropdown.Item aria-label="Move"
            hidden={Feature.hidden(DriveFeature.Move, permissions)}
            data-tooltip-id="dd-tooltip" data-tooltip-content="Move Shared Folder"
            data-tooltip-place="right"
            onClick={() => handleAction({ actionType: DriveUIActionTypes.MoveModal, params: { show: true, entry } })}>
            <Icon className="pv-icon-move" />Move
          </Dropdown.Item>
        </>}
        {
          (!!collection_info && entry.id === collection_info.id) &&
          <WatchedSwitchItem
            current_account={current_account}
            entry={entry}
            hidden={Feature.hidden(DriveFeature.Watch, permissions)}
            collection_info={collection_info}
            current_details={current_details}
            handleAction={handleAction} />
        }
      </>
    }
  </>;
}

export default React.memo(LinkMenuComponent);